<!--accessibility-->
<div id="skiptocontent" [tabIndex]="globalConfigurationService.getAddIndexToSkiptocontent()?null:1" [ngStyle]="{visibility:isAllowedSkipNavigation?'':'hidden'}"><a id="skiptocontent_link" href="#maincontent" tabindex="1" (click)="navigateToAnchor($event)">{{'generic.accessibility_goto_main' | translate}}</a></div>
<!-- PROGRESS BAR -->
<!-- <fuse-progress-bar></fuse-progress-bar> -->
<!-- / PROGRESS BAR -->

<!-- VERTICAL LAYOUT 1 -->
@if (layoutConfig.layout.style === 'vertical-layout-1') {
  <vertical-layout-1 ngClass="{{ brand }}" class="{{ themeColor }}"></vertical-layout-1>
}
<!-- / VERTICAL LAYOUT 1 -->

@if (isSnackbarRecallButtonConfigActive) {
  <app-snackbar-recall-button></app-snackbar-recall-button>
}